interface SectionHeadingProps {
  overline: string;
  title: string;
  note: string;
  id?: string;
}

export default function SectionHeading({ overline, title, note, id }: SectionHeadingProps) {
  return (
    <div id={id} className="mx-auto mb-8 md:mb-12 max-w-3xl text-center scroll-mt-24">
      <p className="mb-3 text-xs font-semibold tracking-[0.3em] uppercase text-secondary-700">
        {overline}
      </p>
      <h4 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
        {title}
      </h4>
      <div className="mx-auto mt-5 h-px w-10 bg-primary-400" />
      <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">{note}</p>
    </div>
  );
}